import { api } from '@/shared/api/client';
import type { LoginResponse } from '@/shared/auth/storage';

export interface OtpStartResponse {
  SessionId: string;
  ExpiresAt: string;
  DisplayInstruction?: string;
}
export type OtpStatus = 'PENDING' | 'VERIFIED' | 'EXPIRED' | 'FAILED';
export interface OtpStatusResponse {
  SessionStatus: OtpStatus;
}

export interface TenantInfo {
  Id: string;
  Code?: string;
  Name: string;
}
export interface CompanyInfo {
  Id: string;
  Code?: string;
  Name: string;
  BusinessType?: number;
}

export const authApi = {
  startOtp: (phone: string) => api.post<OtpStartResponse>('/api/sms-otp/start', { Phone: phone }),
  pollOtp: (sessionId: string) =>
    api.get<OtpStatusResponse>('/api/sms-otp/status/' + encodeURIComponent(sessionId)),
  phoneLogin: (phone: string, sessionId: string) =>
    api.post<LoginResponse>('/api/auth/phone-login', { Phone: phone, SessionId: sessionId }),
  passwordLogin: (phone: string, password: string) =>
    api.post<LoginResponse>('/api/auth/password-login', { Phone: phone, Password: password }),

  myTenants: () => api.get<TenantInfo[]>('/api/tenant/my'),
  companiesByTenant: (tenantId: string) =>
    api.get<CompanyInfo[]>(`/api/company/by-tenant/${tenantId}`),
};
